export const CONTENT_ACTION = 'content';
export const WAITING_ACTION = 'waiting';
export const CLARIFY_ACTION = 'clarifying';
export const SYSTEM_MESSAGE_ACTION = 'system_message';
export const CANCEL_ACTION = 'cancel';
export const QUESTION_ACCEPT = 'accepted';
export const NEW_QUESTION_HAS_BEEN_OPENED = 'question_already_opened';
export const MATCHING_WIN = 'matching_win';



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/constants/messageActions.js